import axios from 'axios';

const API_URL = '/api/v1/alert/';

const getAlerts = ({ isRead, pageIndex, pageSize, userId } = {}) => {
	return axios.get(`${API_URL}`, {
		params: {
			pagination: JSON.stringify({ page: pageIndex, count: pageSize }),
			filter: JSON.stringify({ isRead, userId }),
		},
	});
}

const markAlert = (id, isRead = true) => axios.patch(`${API_URL}mark/${id}`, { isRead });

export {
	getAlerts,
	markAlert,
};
